import axios from 'axios';
import storage from 'src/utils/storageUtils';
import { showLoader, hideLoader } from 'src/components/shared/GlobalLoader';

const isLocalhost = typeof window !== 'undefined' && /^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname || '');
const rawBaseUrl = process.env.REACT_APP_BASE_API_URL || (isLocalhost ? 'http://localhost:1337' : '');
const cleanBaseUrl = rawBaseUrl.replace(/['"]+/g, '').replace(/\/$/, '');
const client = axios.create({
  baseURL: cleanBaseUrl,
});

const handleAuth = (config, isFormData) => {
  const token = storage.get('TOKEN');
  const tenantHash = storage.get('TENANT_HASH');
  
  if (!config.headers) {
    config.headers = {};
  }

  if (token && token !== '' && token !== null && token !== 'undefined') {
    if (typeof config.headers.set === 'function') {
      config.headers.set('Authorization', 'Bearer ' + token);
      if (tenantHash && tenantHash !== 'undefined' && tenantHash !== 'null') {
        config.headers.set('Tenant', tenantHash);
      }
      if (!isFormData) {
        config.headers.set('Content-Type', 'application/json;charset=utf-8');
      }
    } else {
      config.headers['Authorization'] = 'Bearer ' + token;
      if (tenantHash && tenantHash !== 'undefined' && tenantHash !== 'null') {
        config.headers['Tenant'] = tenantHash;
      }
      if (!isFormData) {
        config.headers['Content-Type'] = 'application/json;charset=utf-8';
      }
    }
  }
  return config;
};

client.interceptors.request.use((config) => {
  try {
    console.log('API: Request starting for', config.url);
    const isFD = config.data instanceof FormData;
    return handleAuth(config, isFD);
  } catch (err) {
    console.error('API: Request interceptor error during preprocessing:', err);
    throw err;
  }
}, (error) => {
  return Promise.reject(error);
});

client.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized - clear stale session and redirect to login
    if (error?.response?.status === 401) {
      const currentPath = window.location.pathname;
      // Only redirect if not already on an auth or public login page to avoid loops
      if (!currentPath.startsWith('/auth') && !currentPath.startsWith('/public/login')) {
        console.warn('[API] 401 Unauthorized — clearing session and redirecting to login');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('clinicId');
        sessionStorage.removeItem('doctorname');
        sessionStorage.removeItem('tenantHash');
        
        if (currentPath.startsWith('/public')) {
            window.location.href = '/public/login';
        } else {
            window.location.href = '/auth/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default function api(path, payload, method, isFormData, onUploadProgress, responseType = 'json', params = {}) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  const isValidParamsObject =
    params && typeof params === 'object' && !Array.isArray(params);
  let filteredParams = {};
  if (isValidParamsObject) {
    filteredParams = Object.fromEntries(
      Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== '',
      ),
    );
  }

  console.log("normalizedPath", normalizedPath);

  return new Promise((resolve, reject) => {
    client
      .request({
        method,
        url: normalizedPath,
        params: filteredParams,
        responseType,
        data: payload || {},
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': '0'
        },
        ...(onUploadProgress && { onUploadProgress }),
      })
      .then((response) => resolve(response.data))
      .catch((error) => {
        const errData =
          error?.response?.data || { message: error?.message || 'Something went wrong' };
        reject(errData);
      });
  });
}

